import * as React from "react";
import { useEffect } from "react";
import CartLeftContent from "./Cart/CartLeftContent/CartLeftContent";
import CartRightContent from "./Cart/CartRightContent/CartRightContent";
import System from "src/helper/system";
import store from "../storeWire";
import { system_notification } from "../store/slice/system";
import $ from "jquery";
import FadeInOut from "../component/FadeInOut";
import AxiosSingletonLoader from "../component/AxiosSingletonLoader";
import { useCartStore } from "src/hooks/cart";
import ShippingAddressPopup from "./Cart/CartModals/ShippingAddressPopup";
import { __set, __remove } from "src/store/axios_indicator";
import useReduxState from "src/hooks/useReduxState";
import Constants from "src/support/Constants";
import CommonCart from "src/component/Global/Cart/Common";
import CartRepository from "src/repository/CartRepository";

export function Cart() {
  const [{ CART_DATA, CART_PRODUCT_DATA }, { initiatedKernelCall, initiatedKernelSyncCurrencyCall }, { }] = useCartStore();
  const [isCartPriceAlert, setCartPriceAlert] = useReduxState(false, 'setCartPriceAlert');

  const fetchFromServer = async () => {
    __set('CART_API_CALL');
    await initiatedKernelCall()
    await initiatedKernelSyncCurrencyCall()
    __remove('CART_API_CALL');

  };

  React.useLayoutEffect(() => {
    async function fetchHere() {
      await fetchFromServer();
    }
    fetchHere();
  }, [])

  const getClassToDisplay = () => {
    return true;
  };

  useEffect(() => {
    let c = System.getParams();
    if (c.ShippingAddressPopup !== undefined && c.ShippingAddressPopup === "1") {
      store.dispatch(
        system_notification({
          name: "ShippingAddressPopup",
          data: [],
        })
      );

      history.pushState(null, null, "?" + $.param(c));
    }
    sessionStorage.setItem("successUrl", "cart")
    sessionStorage.removeItem("invoiceAddress")
  }, []);

  useEffect(() => {
    validateCartEOLObsoleteExist();
    updateCartData(CART_DATA)
  }, [CART_DATA, CART_PRODUCT_DATA]);

  /**
   * UpdateCartData is call when old data is there in cart before manual option change is there in database and cpntype not match with cpn dropdown
   * Author: Devanshi Patel
   */
  const updateCartData = async (cartData) => {
    if (Array.isArray(cartData) && cartData.length > 0 && CART_PRODUCT_DATA && Object.entries(CART_PRODUCT_DATA).length > 0) {
      let status = false
      const pArray = await Promise.all(CART_DATA.map(async (v) => {
        let single_product = CART_PRODUCT_DATA[v.itemNumber]
        if (v?.cpnTypeName === Constants.cpnTypes.CPN && CommonCart.isCpnIsManual(single_product, v.cpn)) {
          status = true
          let cartData = new CartRepository().getCartItemByCartDetailID(v.cartDetailId)
          let param = {
            ...cartData,
            cpnType: Constants.cpnTypes.MANUALCPN,
            cpn: '',
            manualCPN: v.cpn ? v.cpn : ''
          }

          return param;
        } else {
          let cartData = new CartRepository().getCartItemByCartDetailID(v.cartDetailId)
          let param = {
            ...cartData
          }

          return param;
        }
      }));
      if (status) {
        await new CartRepository().UpdateCartItemsServer(pArray, true, true)
      }

    }
  }

  const validateCartEOLObsoleteExist = () => {
    let cartArr = [];
    if (CART_PRODUCT_DATA && CART_DATA && Array.isArray(CART_DATA) && CART_DATA.length > 0) {
      if (Object.entries(CART_PRODUCT_DATA).length > 0) {
        Object.entries(CART_DATA).forEach((x, y) => {
          let s = {
            isObsoleteFlag: CART_PRODUCT_DATA[x[1]["ERPPartNumber"]] ? CART_PRODUCT_DATA[x[1]["ERPPartNumber"]].ObsoleteFlag : false,
            isEOLFlag: CART_PRODUCT_DATA[x[1]["ERPPartNumber"]] ? CART_PRODUCT_DATA[x[1]["ERPPartNumber"]].EndOfLifeOFlag : false,
            isNCNRFlag: CART_PRODUCT_DATA[x[1]["ERPPartNumber"]] ? CART_PRODUCT_DATA[x[1]["ERPPartNumber"]].NCNRFlag : false,
            unitPrice: x[1].unitPrice ? x[1].unitPrice : 0,
            subTotal: x[1].subtotal ? x[1].subtotal : 0,
            quantity:x[1].quantity,
            adjusted_qty:x[1]?.adjustedQuantity
          };
          cartArr.push(s);
        });
      }
    }
    let fireAlert = 0;
    let ncnrAlert = 0;
    let emptyPriceItem = 0;

    if (cartArr && cartArr.length > 0 && (cartArr.filter((x) => x.isObsoleteFlag === true).length > 0 || cartArr.filter((x) => x.isEOLFlag === true).length > 0)) {
      fireAlert++;
    }

    /**
     * Author : Trilok and Pankaj
     * Date: 08-02-2023
     * Reason: Dsiplay NCNR Flag
     */
    if (cartArr && cartArr.length > 0 &&
      (cartArr.filter((x) => x.isNCNRFlag === true).length > 0 || cartArr.filter((x) => x.isNCNRFlag === true).length > 0)) {
      ncnrAlert++;
    }

    if (fireAlert === 1) {
      System.alert("This cart contains EOL/Obsolete part.", "danger", "", true);
    }

    if (ncnrAlert === 1) {
      setTimeout(() => {
        System.alert(
          "Your cart contains <b>NCNR:</b> <span>Non-Cancelable/Non-Returnable parts.</span>",
          "warning"
        );
      }, 1000);
    }

    /**
     * Author : Pankaj
     * Ticket : 13392
     * Date   : 05 Oct,2023
     * Change : Display message if unit price is 0
     */
    if (cartArr !== undefined && cartArr !== null && cartArr.length > 0 && (
      (cartArr.filter((x) => x.unitPrice == 0 || x.subTotal == 0).length > 0) || 
      (cartArr.filter(x=>x.quantity < x.adjusted_qty).length > 0))) {
      emptyPriceItem++;
    }

    if (isCartPriceAlert && emptyPriceItem != 1) {
      setCartPriceAlert(false);
    }
    else if (emptyPriceItem === 1) {
      setCartPriceAlert(true);
    }

  };

  return (
    <>
      <ShippingAddressPopup />
      <div className="logged-screen cart-container">
        <div className="container">
          <FadeInOut show={getClassToDisplay()} duration={100} style={{}}>
            <div className={getClassToDisplay() ? "bs5 row" : ""}>
              <CartLeftContent />
              {getClassToDisplay() && <CartRightContent />}
            </div>
          </FadeInOut>
          <div className={"bs5 row"}>
            <AxiosSingletonLoader />
          </div>
        </div>
      </div>
    </>
  );
}
